var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCategories = function SvgCategories(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.983 5.96A3.49 3.49 0 0 0 8.667 5H6.284a.167.167 0 0 1-.15-.239A1.33 1.33 0 0 1 7.333 4h3.333a2.5 2.5 0 0 1 1.608.663l7.333 7.334a1.333 1.333 0 0 1 0 1.884l-.44.44a.165.165 0 0 1-.232.005.165.165 0 0 1-.045-.072 2.314 2.314 0 0 0-.574-.961l-7.334-7.334zm1.45 13.94a1.32 1.32 0 0 1-.433-.291l-7.333-7.333A2.495 2.495 0 0 1 4 10.666V7.334A1.333 1.333 0 0 1 5.333 6h3.334a2.5 2.5 0 0 1 1.61.668l7.333 7.333a1.333 1.333 0 0 1 0 1.885l-1.724 1.724-2 2a1.325 1.325 0 0 1-.943.39 1.32 1.32 0 0 1-.51-.1zM8.222 8.834a1 1 0 1 0-1.112 1.663 1 1 0 0 0 1.111-1.663z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCategories);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "categories.4c0e64ee9b0f6599cf9ded34a27f3e29.svg";